export default __webpack_public_path__ + "static/media/q33.b8c0c1ae.png";